export const environment = {
  production: false,
  restApiPrefix: 'https://portal-test.nannytax.com:8443/api/v1',
  serverPrefix : 'https://portal-test.nannytax.com',
  calculationApiLimitPerClient: 25
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts